@if (!isLoading) {
    <div class="main-navbar-container max-width-container">
        <navbar
            class="main-navbar side-padding flex lg:flex-row flex-col font-medium xl:text-lg lg:text-base text-sm pt-3">
            <ng-container *ngFor="let item of menu; let i = index">
                @if (userDetails?.isAAEEnabled || item.menuType !== MenuType.AskAnExpert) {
                    <a
                        *ngIf="!item.children"
                        class="menu-link menu-item relative"
                        [id]="item.htmlId"
                        [ngClass]="item.cssClass"
                        [routerLink]="item.link"
                        (click)="onLinkClick(item.param)">
                        {{ item.label | translate }}
                        <span
                            *ngIf="item.icon"
                            class="icon-[1.5rem] absolute top-[-0.75rem] lg:-top-2.5"
                            [ngClass]="item.icon"></span>
                    </a>

                    <div *ngIf="item.children" class="sub-menu-container lg:relative">
                        <button
                            type="button"
                            [ngClass]="{ 'menu-item flex': isMobile }"
                            (click)="isMobile && toggleMenu(item.menuType, true)">
                            <a
                                class="flex items-center lg:justify-start justify-between"
                                [ngClass]="isMobile ? 'max-w-fit' : 'menu-item'"
                                [id]="item.htmlId"
                                [routerLink]="item.link"
                                (click)="
                                    item.link ? $event.stopPropagation() : null;
                                    item.link ? onLinkClick(item.param) : null
                                "
                                (mouseenter)="!isMobile && toggleMenu(item.menuType, true)">
                                {{ item.label | translate }}
                                <span
                                    *ngIf="!isMobile"
                                    class="inline-block icon-[0.625rem] ml-2 bg-arrow-up-icon transition-all duration-200"
                                    [ngClass]="
                                        selectedMainMenuType !== null && selectedMainMenuType === item.menuType
                                            ? 'rotate-0'
                                            : 'rotate-180'
                                    "></span>
                            </a>

                            <span
                                *ngIf="isMobile"
                                class="inline-block icon-[0.625rem] ml-auto bg-arrow-up-icon transition-all duration-200"
                                [ngClass]="
                                    selectedMainMenuType !== null && selectedMainMenuType === item.menuType
                                        ? 'rotate-0'
                                        : 'rotate-180'
                                "></span>
                        </button>
                        <div
                            *ngIf="item.menuType === selectedMainMenuType"
                            #dropdownMenu
                            class="custom-menu"
                            [ngClass]="item.isColumnLayout ? 'menu-panel--columns' : 'menu-panel--list'"
                            (mouseleave)="toggleMenu(item.menuType, false)">
                            @if (item.isColumnLayout) {
                                <div class="menu-columns">
                                    @for (column of item.children; track $index) {
                                        <div class="menu-column">
                                            @if (column.link) {
                                                <a
                                                    class="menu-column__header"
                                                    [routerLink]="column.link"
                                                    (click)="onLinkClick(column.param)">
                                                    {{ column.label | translate }}
                                                </a>
                                            } @else {
                                                <span class="menu-column__header">
                                                    {{ column.label | translate }}
                                                </span>
                                            }
                                            <ul class="menu-column__items">
                                                @for (child of column.children; track $index) {
                                                    <li>
                                                        <a [routerLink]="child.link" (click)="onLinkClick(child.param)">
                                                            {{ child.label | translate }}
                                                        </a>
                                                    </li>
                                                }
                                            </ul>
                                        </div>
                                    }
                                </div>
                            } @else {
                                <ul class="menu-column__items">
                                    @for (child of item.children; track $index) {
                                        <li>
                                            <a
                                                [routerLink]="child.link"
                                                [ngClass]="child.cssClass"
                                                (click)="onLinkClick(child.param)">
                                                {{ child.label | translate }}
                                            </a>
                                        </li>
                                    }
                                </ul>
                            }
                        </div>
                    </div>
                }
            </ng-container>
        </navbar>
    </div>
}
